import React, {useEffect, useState} from 'react';
import './headerlist.scss'

const HeaderList = () => {
	const [HeaderData, setHeaderData] = useState ([]);
	
	const getAllHeaderData = async () => {
		try {
			const response = await fetch ('/data/uielements.json');
			if (!response.ok) {
				throw new Error ('Failed to fetch data');
			}
			const data = await response.json ();
			const filterHeaderData = data.UIElements?.filter ((uicode) => uicode.UIElementId === "UIElemetHeader");
			setHeaderData (filterHeaderData || []);
		} catch (err) {
			console.error ('Error fetching loader data:', err);
		}
	}
	
	useEffect (() => {
		getAllHeaderData ();
	}, []);
	
	const handleDownload = (file) => {
		const link = document.createElement ('a');
		link.href = file;
		link.download = file.split ('/').pop (); // Extract file name from path
		document.body.appendChild (link);
		link.click ();
		document.body.removeChild (link);
	};
	
	const handlePayAmount = (filePay) =>{
		const link = document.createElement ('a');
		link.href = filePay;
		link.download = filePay.split ('/').pop ();;
		document.body.appendChild (link);
		link.click ();
		document.body.removeChild (link);
	}
	
	return (
		<div className="mainHeaderList">
			<div className="subHeaderList">
				{
					HeaderData.length === 0 ? (
						<p>No Data</p>
					) : (
						HeaderData.map ((item, index) => (
							<div className="HeaderList" key={index}>
								<div className="HeaderListUIElements-image-box">
									<img src={item.VideoGif} alt=""/>
								</div>
								<div className="HeaderListInfo">
									<div className="title">{item.title}</div>
									<p>{item.Developer}</p>
									<div className="mainDownloadBtn">
										{
											item.PayAmount === "Yes" ?(
												<>
													<button onClick={() => handlePayAmount(item.PayAmountUrl)}>Pay</button>
												</>
											): (
												<button className='DownloadBtn' onClick={() => handleDownload (item.ZipFile)}>Download</button>
											)
										}
									
									</div>
								</div>
							</div>
						))
					)
				}
			</div>
		</div>
	);
};

export default HeaderList;